<template>
  <v-container fluid>
    <div v-if="ready == true">
      <v-row>
        <v-col
          cols="12"
          md="10"
          offset-md="1"
          lg="10"
          offset-lg="1"
          xl="10"
          offset-xl="1"
        >
          <v-row class="pt-5">
            <v-col cols="12">
              <v-toolbar flat dense color="#fafafa">
                <v-toolbar-title
                  class="contentHeader"
                  v-if="$vuetify.breakpoint.lgAndUp"
                  >{{ categoryTitle }}</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-menu offset-y left>
                  <template v-slot:activator="{ on }">
                    <v-btn text :color="$buttonColor" v-on="on">
                      <v-icon left>{{
                        sortOrder == 1
                          ? "far fa-sort-amount-up-alt"
                          : "far fa-sort-amount-down-alt"
                      }}</v-icon
                      >Sort
                    </v-btn>
                  </template>

                  <div class="white">
                    <div class="pa-4 pb-0">
                      <v-btn-toggle
                        mandatory
                        v-model="sortOrder"
                        @change="changeSortOrder"
                      >
                        <v-btn small>Ascending</v-btn>
                        <v-btn small>Descending</v-btn>
                      </v-btn-toggle>
                    </div>
                    <v-divider class="my-2"></v-divider>
                    <v-list tile class="pt-0" dense min-width="240px">
                      <template v-for="(item, index) in sortByOptions">
                        <v-list-item
                          :key="`sortBy_${index}`"
                          @click="updateUrl('sortby', item)"
                          :class="{
                            'primary--text v-list-item--active':
                              (sortBy || null) == item.param,
                          }"
                        >
                          <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item>
                        <v-divider
                          v-if="index != sortByOptions.length - 1"
                          :key="`div_sortBy_${index}`"
                        ></v-divider>
                      </template>
                    </v-list>
                  </div>
                </v-menu>
                <!-- <div class="py-2 ml-3 mr-2 fill-height">
                  <v-divider vertical></v-divider>
                </div>
                <v-menu offset-y left>
                  <template v-slot:activator="{ on }">
                    <v-btn text :color="$buttonColor" v-on="on">
                      <v-avatar size="24" class="grey lighten-2 mr-2">
                        <span class="overline">{{
                          itemsPerPage == -1 ? "+" : itemsPerPage
                        }}</span> </v-avatar
                      >Limit
                    </v-btn>
                  </template>
                  <div class="pa-0">
                    <v-list dense>
                      <template v-for="(item, index) in pagingOptions">
                        <v-list-item
                          :key="`ipp_${index}`"
                          @click="updateUrl('ipp', item)"
                          :class="{
                            'primary--text v-list-item--active':
                              item == itemsPerPage,
                          }"
                        >
                          <v-list-item-title>{{
                            item == -1 ? "All" : item
                          }}</v-list-item-title>
                        </v-list-item>
                        <v-divider
                          v-if="index != pagingOptions.length - 1"
                          :key="`div_ipp_${index}`"
                        ></v-divider>
                      </template>
                    </v-list>
                  </div>
                </v-menu> -->
              </v-toolbar>
            </v-col>
          </v-row>
          <!-- course render -->
          <course-renderer
            :courses="courses"
            :items-per-page="itemsPerPage"
            :show-loader="courseLoader"
            :page.sync="currentPage"
          ></course-renderer>
          <!-- course rende -->

          <v-row class="pt-5" justify="end">
            <v-pagination
              v-model="page"
              :length="pageCount"
              @input="changePage"
              :color="$buttonColor"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
            ></v-pagination>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import CourseRenderer from "@/components/NewCourseRenderer.vue";
import { EventBus } from "@/event-bus";
export default {
  name: "new_course_list",
  components: {
    CourseRenderer,
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    courseViewTitle: "",
    courseLoader: false,
    currentPage: 1,
    reloadMode: true,
    itemsPerPage: 10,
    sortBy: "created_at",
    sortOrder: 1,
    ready: false,
    showSkeleton: true,
    errOnPage: false,
    courses: null,
    categoryTitle: "",
    pagingOptions: [3, 10, 20, 30],
    sortByOptions: [
      {
        param: "created_at",
        text: "Created",
      },
      {
        param: "title",
        text: "Title",
      },
      {
        param: "rating",
        text: "Rating",
      },
    ],
    sidebarFilter: {},
  }),
  beforeDestroy() {
    EventBus.$off("updateUrl");
  },
  mounted() {
    EventBus.$on("updateUrl", (flag, val) => {
      this.updateUrl(flag, val);
    });
    this.init();
  },
  watch: {
    $route(to, from) {
      this.init();
    },
    currentPage(val, oldVal) {
      if (val != oldVal) {
        this.updateUrl("page", val);
      }
    },
  },
  methods: {
    init() {
      this.paramsManager();
    },
    async changePage(page) {
      this.page = page;
      await this.init();
    },
    paramsManager() {
      let qs = this.$utility.vueRouterQueryToJson(this.$route.query);
      this.categoryTitle = this.$route.query.title;
      // let sortBy = "created_at";
      let sortOrder = this.$route.query.sortby || -1;
      let ipp = this.$route.query.limit || 10;

      this.sortOrder = this.$utility.getLocalSortOrder(sortOrder);
      // this.sortBy = this.sortByOptions.find((x) => x.param == sortBy);
      this.sortBy = qs.sort;
      this.itemsPerPage = ipp;
      this.currentPage = this.$route.query.page || 1;

      this.loadSidebar();
    },
    loadSidebar() {
      this.$http
        .get(`${this.$store.state.api}/home/menu/sidebar`)
        .then((resp) => {
          if (resp.status == 200 && resp.data.status) {
            this.sidebarFilter = resp.data.result;
            // console.log(this.sidebarFilter);
            this.loadCourse();
          }
        })
        .catch(() => {
          // notify error
        });
    },
    searchSkill() {},
    changeSortOrder(val) {
      this.updateUrl("sortorder", val);
    },
    updateUrl(flag, value) {
      if (this.reloadMode) {
        let qs = this.$utility.vueRouterQueryToJson(this.$route.query);
        if (flag == "sortorder") {
          qs.sortby = this.$utility.getApiSortOrder(value);
        } else if (flag == "sortby") {
          qs.sort = value.param;
          this.sortBy = value.param;
        } else if (flag == "ipp") {
          qs.limit = value;
        } else if (flag == "page") {
          qs.page = value;
        } else if (flag == "category") {
          if (value != null) {
            qs.category = value;
          } else {
            delete qs.category;
          }
        } else if (flag == "grade") {
          if (value != null) {
            qs.grade = value;
          } else {
            delete qs.grade;
          }
        } else if (flag == "skill") {
          if (value != null) {
            qs.skill = value;
          } else {
            delete qs.skill;
          }
        }
        this.$nextTick(() => {
          this.$router
            .replace({
              query: qs,
            })
            .catch(() => {
              // do nothing
              // window.location = "/course?" + this.$utility.routerQueryStringToUrlParams(qs);
            });
        });
      } else {
        if (flag == "sortorder") {
          // this.sortOrder = value;
        } else if (flag == "sortby") {
          this.sortBy = value;
        } else if (flag == "ipp") {
          this.itemsPerPage = value;
        }
        this.loadCourse();
      }
    },
    loadCourse() {
      this.courseLoader = true;
      this.createCourseRequest()
        .then((resp) => {
          if (resp.data.status) {
            let findAllCourses = resp.data.result.elements.filter(
              (x) => x.template == "course_vertical_gridview"
            );
            this.courses = [];
            this.pageCount = findAllCourses[0].maxPage;
            for (let section of findAllCourses) {
              if (section.body != null && section.body.length > 0) {
                for (let course of section.body) {
                  this.courses.push(course);
                }
              }
            }

            this.ready = true;
          } else {
            this.errOnPage = true;
            this.ready = false;
          }
          console.log(this.courses);
          console.log(this.pageCount);
        })
        .catch((err) => {
          this.ready = false;
          this.errOnPage = true;
        })
        .finally(() => {
          this.showSkeleton = false;
          setTimeout(() => {
            this.courseLoader = false;
          }, 500);
        });
    },
    createCourseRequest() {
      console.log(
        "createCourseRequest -> this.$route.query",
        this.$route.query
      );
      let url = `${this.$store.state.api}`;
      let category = this.$route.query.category || null;

      let skill = this.$route.query.skill || null;
      let grade = this.$route.query.grade || null;
      let type = this.$route.query.type || null;
      let search = this.$route.query.search || null;
      let stdParams = {
        sort: this.sortBy,
        sortby: this.$utility.getApiSortOrder(this.sortOrder),
        page: this.currentPage,
      };
      if (this.itemsPerPage != -1) {
        stdParams.limit = this.itemsPerPage;
      }
      console.log("fff");
      console.log(stdParams);
      if (type != null && type != "null") stdParams.type = type;
      if (category != null && category != "null") stdParams.category = category;
      if (grade != null && grade != "null") stdParams.grade = grade;
      if (skill != null && skill != "null") stdParams.skill = skill;
      if (search != null && search != "null") stdParams.search = search;

      url += `/list/filter?${this.$utility.routerQueryStringToUrlParams(
        stdParams
      )}`;

      // if (categories == null && skills == null && grades == null) {
      //   url +=
      //     "/home/course?" +
      //     this.$utility.routerQueryStringToUrlParams(stdParams);
      //   this.courseViewTitle = "COURSES";
      // } else {

      // }

      // create request
      return this.$http.get(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-expansion-panel-content ::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}
.course-list-container {
  padding-left: 16px;
  padding-right: 16px;
}
.contentHeader {
  font-size: 26px;
  font-weight: bold;
  color: #000000;
}
.myCourseTitle {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.38;
  color: #4a4a4a;
  margin-bottom: 0px;

  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* min-height: 35px;
  max-height: 43px; */
}
</style>